<template>
  <div class="navContainer">
    <div id="profile-picture-container" class="link" @click="toProfile">
      <img class="profile-picture" :src="profilePictureSrc" alt="" :class="defaultProfilePicture ? '' : 'profile-picture-border'">
      <p class="white regular-weight underline display-name">
        {{ this.$store.getters.userDetails.displayName || "Logged in" }}
      </p>
    </div>
    <div class="button-container flex-grow">
      <!-- <div class="link" @click="createArtwork">
        <img src="~@/assets/create-artwork-button-small.png" alt="">
        <p class="white">Create artwork</p>
      </div> -->
      <div class="divider"></div>
      <div :class="['link-parent', $route.path === '/artworks' ? 'active' : '']">
        <div class="link" @click="toArtworks">
          <img src="~@/assets/artworks-button.png" alt="">
          <p class="white">
            Artworks
          </p>
        </div>
      </div>
      <div :class="['link-parent', $route.path === '/collections' ? 'active' : '']">
        <div class="link" @click="toCollections">
          <img src="~@/assets/collections-button.png" alt="">
          <p class="white">
            Collections
          </p>
        </div>
      </div>
      <div class="divider"></div>
      <div :class="['link-parent', $route.path === '/panels' ? 'active' : '']">
        <div class="link panels-link" @click="toPanels">
          <img src="~@/assets/panels-button-new.png" alt="">
          <p class="white">
            Panels
          </p>
        </div>
      </div>
      <div class="divider"></div>
    </div>
    <div class="subscription-container">
      <p class="plan-name regular-weight">
        {{ currentPlan }}:
      </p>
      <p class="views">
        {{ formattedViewCount }} of {{ formattedViewCap }} Views
      </p>
      <ProgressBar :max="viewCap" :current="viewCount" />
      <SubscribeButton :small="true" />
    </div>
    <p class="version">Version {{ appVersion }} ({{ buildHash }})</p>
  </div>
</template>

<script>
import { shell } from 'electron';
import uuidv4 from 'uuid/v4';

import SubscribeButton from '@/components/SubscribeButton';
import ProgressBar from '@/components/ProgressBar';

// import GetPaymentPlans from "@/queries/GetPaymentPlans";

export default {
  name: 'LeftNav',
  components: {
    SubscribeButton,
    ProgressBar
  },
  props: {
    showHeader: {
      type: Boolean,
      required: false
    },
    showTitle: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    appVersion() {
      // Use version from package.json (injected via webpack DefinePlugin)
      return process.env.VUE_APP_VERSION || '0.0.0';
    },
    buildHash() {
      // Git commit hash (short) injected at build time
      return process.env.VUE_APP_BUILD_HASH || 'dev';
    },
    profilePictureSrc() {
      return (
        this.$store.getters.userDetails.profilePictureSrc ||
        require('@/assets/default-user-icon.png')
      );
    },
    defaultProfilePicture() {
      return !this.$store.getters.userDetails.profilePictureSrc;
    },
    currentPlan() {
      let plan = this.$store.getters.userDetails.group;
      return (plan.charAt(0).toUpperCase() + plan.slice(1)) + ' plan';
    },
    viewCap() {
      return this.$store.getters.viewCap;
    },
    viewCount() {
      return this.$store.getters.viewCount;
    },
    formattedViewCount() {
      return this.$store.getters.viewCount.toLocaleString();
    },
    formattedViewCap() {
      return this.$store.getters.viewCap.toLocaleString();
    }
  },
  methods: {
    fairUse() {
      shell.openExternal('https://eyejack.page.link/fairuse');
    },
    toProfile() {
      this.$router.push({ name: 'user-page' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
      console.log('username clicked');
    },
    createArtwork() {
      this.$router.push({ name: 'new-artwork-page' }).catch(() => {});
      console.log('create artwork clicked');
    },
    toArtworks() {
      this.$router.push({ name: 'artworks-page' }).catch(err => {
        // Ignore NavigationDuplicated errors (clicking nav while already on page)
        if (err.name !== 'NavigationDuplicated') throw err;
      });
      console.log('artworks clicked');
    },
    toCollections() {
      this.$router.push({ name: 'collections-page' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
      console.log('collections clicked');
    },
    toPanels() {
      this.$router.push({ name: 'panels-page' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
      console.log('panels clicked');
    },
    toPanelsEdit() {
      // New Panels project — mint an Artwork id for the /panels/:id route (a
      // param-less push falls back to "/"), flagged new so PanelsEditPage creates it.
      const id = 'Artwork-' + uuidv4();
      this.$router.push({ name: 'panels-edit-page', params: { id, isNew: true } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "../styles/main.styl"

.navContainer {
  z-index: $navbar-z-index;
  height: 100%
  max-width: 150px
  min-width: 150px
  background: color-title-bar
  display: flex
  flex-direction: column
  text-align: center
  padding: 40px 0 30px 0;
  box-sizing: border-box;
  // Scroll vertically when the menu is taller than the window so every button
  // stays reachable on short viewports; never scroll horizontally.
  overflow-y: auto;
  overflow-x: hidden;
  // Keep the elastic over-scroll within the menu (its own dark background)
  // instead of chaining to the white document underneath.
  overscroll-behavior: contain;
  position: relative;

  // Keep each section at its natural height so the container scrolls instead of
  // squashing the buttons when the window is short.
  > * {
    flex-shrink: 0;
  }

  .display-name {
    overflow-wrap: break-word;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 40px;
  }

  div.link-parent {
    height: 138px;
    display: flex;
    flex-direction: column;
    transition: all 0.2s;

    border-right: 4px solid rgba(0, 0, 0, 0);
    border-left: 4px solid rgba(0, 0, 0, 0);
    background: rgba(0, 0, 0, 0);

    &.active {
      border-left-color: #E95557;
      // background: linear-gradient(180deg, #5F5D5D 0%, #4E4E4E 98%);
      background: #4E4E4E;
    }
  }

  div.link {
    margin: auto 0;
    transition: transform 0.1s;

    &:hover {
      cursor: pointer
      transform: scale(1.05)
    }

    p {
      font-size: 14px
      margin-bottom: 0
      margin-top: 10px
    }

    img {
      height: 75px;
    }
  }

  div.panels-link {
    img {
      height: 84px;
    }
  }

  .profile-picture-container {
    margin-bottom: 64px
  }

  .divider {
    margin 0 20px
    padding 0
    width 110px
    border-bottom 1px solid color-body-text
  }

  .subscription-container {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px 0 20px;
    text-align: left;
    margin-top: auto;
    margin-bottom: 20px;

    p {
      margin: 0;
    }

    .plan-name {
      color: white;
      font-size: 12px
    }

    .views {
      color: color-light-grey;
      font-size: 10px
    }

  }

  .version {
    color: white;
    font-size: 10px;
    position: absolute;
    bottom: 15px;
    left: 0;
    right: 0;
    text-align: center;
    margin: 0;
  }

  .fair-use {
    font-size: 12px;
    color: white;
    width: 100px;
  }
}

// Mobile: turn the fixed 150px rail into an off-canvas slide-in drawer.
// Desktop is untouched — it keeps the static 150px rail above.
@media (max-width: mobile-breakpoint) {
  // Slide the desktop 150px rail in from the left as an off-canvas drawer. Everything else —
  // width, button spacing, dividers — is inherited from the desktop rail above, unchanged; only
  // the positioning and slide-in transition are added here.
  .navContainer {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    z-index: $modal-z-index;
    box-shadow: 2px 0 14px rgba(0, 0, 0, 0.35);
    // Clear the iOS notch/home indicator when the drawer is full-height (adds to the base 40/30 padding).
    padding-top: calc(40px + env(safe-area-inset-top));
    padding-bottom: calc(30px + env(safe-area-inset-bottom));
  }

  .navContainer.mobile-open {
    transform: translateX(0);
  }
}
</style>
